/**
 * The message channels the analytics endpoints report on, in the order the UI
 * lists them.
 */
export const MESSAGE_CHANNELS = [
  'email',
  'pushNotification',
  'textMessage',
  'viberMessage',
  'whatsappMessage',
  'webhook',
];

/**
 * Whether a message channel can actually be used on this domain. SMS and Viber
 * need the full sender credential trio on the domain; WhatsApp needs a linked
 * account. Email, push and webhook have no per-domain credentials, so they are
 * always available.
 * @param {string} channel - one of MESSAGE_CHANNELS
 * @param {object} sources
 * @param {object} sources.domain - `state.domain.domain`
 * @param {object} [sources.whatsappAccount] - `state.whatsapp.account`
 * @returns {boolean}
 */
export const isChannelConfigured = (channel, { domain, whatsappAccount }) => {
  switch (channel) {
    case 'textMessage':
      return Boolean(domain.textMessageSender && domain.textMessageSenderUser && domain.textMessageSenderPassword);
    case 'viberMessage':
      return Boolean(domain.viberMessageSender && domain.viberMessageSenderUser && domain.viberMessageSenderPassword);
    case 'whatsappMessage':
      return Boolean(whatsappAccount && whatsappAccount.whatsappAccountId);
    default:
      return true;
  }
};

/**
 * The MESSAGE_CHANNELS this domain has configured, in MESSAGE_CHANNELS order.
 * @param {object} sources - same shape as `isChannelConfigured`
 * @returns {string[]}
 */
export const configuredChannels = ({ domain, whatsappAccount }) =>
  MESSAGE_CHANNELS.filter((channel) => isChannelConfigured(channel, { domain, whatsappAccount }));
